import { useAuth } from '../../context/AuthContext';
import { hasPermission, ROLES } from '../../config/rolePermissions';
import AccessDenied from './AccessDenied';

export default function RoleBasedRoute({ children, allowedRoles, requiredPermissions, requireAll = false }) {
  const { user } = useAuth();
  const roleOk = !allowedRoles || user?.role === ROLES.ADMIN || allowedRoles.includes(user?.role);
  const permOk = !requiredPermissions || hasPermission(user, requiredPermissions, requireAll);
  if (!roleOk || !permOk) return <AccessDenied what="view this page" />;
  return children;
}
